import { SyntheticEvent, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useCookies } from "react-cookie";
import { AccessRequestType, AccessType, CustomerFeatureType, CustomerListType, PermissionsType, SecretarySimpleType, SelectedParametersType, UserType, VehicleListType } from "../../../../types/types";

import { customerDefault, MENUS_ITENS, PROFILE_ACESSES, secretaryDefault } from "../../../../consts/consts";

import { cpfFormatter, getApiErrorMessage, getFilteredList, registerFormatter, setToastRefToOpen } from "../../../../functions/functions";

import { Autocomplete, Box, Button, Checkbox, Chip, createFilterOptions, FormControl, FormControlLabel, FormGroup, FormHelperText, Grid, IconButton, InputLabel, Paper, Skeleton, Stack, Step, StepContent, StepLabel, Stepper, styled, Switch, SwitchProps, TextField, Tooltip, Typography } from "@mui/material";

import { ArrowForwardOutlined, BadgeOutlined, CheckCircleRounded, CloseOutlined, DeleteForeverOutlined, DriveFileRenameOutlineOutlined, EmailOutlined, KeyOutlined, LockOpenOutlined, LockPersonOutlined, LockResetOutlined, NoAccountsRounded, PinOutlined, RemoveCircleOutlineOutlined, SaveOutlined, UndoOutlined, VisibilityOffOutlined, VisibilityOutlined, VpnKeyOutlined } from "@mui/icons-material";

import { ContentProps, Toast } from "primereact/toast";

import { SetterOrUpdater, useRecoilValue } from "recoil";

import { userAtom } from "../../../../atoms/atoms";
import GridTemplate from "../../../../components/GridTemplate";
import { GridColDef } from "@mui/x-data-grid";
import Rmodal from "../../../../components/Rmodal";

import validator from "validator";
import saveAcessesByCustomer from "../../../../resources/Api/accesses/saveAcessesByCustomer";
import updateUserStatusById from "../../../../resources/Api/accesses/updateUserStatusById";
import resetUserPasswordById from "../../../../resources/Api/accesses/resetUserPasswordById";
import findAllAcessesByCustomer from "../../../../resources/Api/accesses/findAllAcessesByCustomer";
import updateUserByCustomer from "../../../../resources/Api/accesses/updateUserByCustomer";
import findAllUsersExportResponse from "../../../../resources/Api/accesses/findAllUsersExportResponse";
import customerFindAllListResponse from "../../../../resources/Api/customer/customerFindAllListResponse";
import { findCurrentCustomerFeatures, findCustomerFeatures } from "../../../../resources/Api/customerParameter/customerFeatures";
import findAllVehiclesByCustomerIdAndSecretaryIdAndDepartmentIdListResponse from "../../../../resources/Api/vehicle/findAllVehiclesByCustomerIdAndSecretaryIdAndDepartmentIdListResponse";
import { isImpersonationLocked } from "../../../../utils/impersonation";

const filterDriverVehicles = createFilterOptions<string>();

const columns: GridColDef[] = [
    {
        field: "activated",
        type: "boolean",
        width: 150,
        editable: false,
        sortable: false,
        renderHeader: () => (
            <Chip
                sx={{
                    color: "#fff",
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={"Ativo"}
                icon={<KeyOutlined style={{ height: 30, width: 30, fill: "#ffff" }} />}
            />
        ),
        renderCell: (item) => (
            <Chip
                sx={{ background: "transparent" }}
                icon={
                    item.row.activated ? (
                        <CheckCircleRounded
                            className="activated"
                            style={{ height: 28, width: 28 }}
                        />
                    ) : (
                        <NoAccountsRounded
                            className="deactivated"
                            style={{ height: 28, width: 28 }}
                        />
                    )
                }
            />
        ),
    },
    {
        field: "blocked",
        type: "boolean",
        width: 150,
        editable: false,
        sortable: true,
        renderHeader: () => (
            <Chip
                sx={{
                    color: "#fff",
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={"Bloqueado"}
                icon={
                    <LockOpenOutlined style={{ height: 30, width: 30, fill: "#ffff" }} />
                }
            />
        ),
        renderCell: (item) => (
            <div style={{ background: "transparent", fontFamily: "Prometo" }}>
                {item.row.blocked ? (
                    <Chip label={<Typography className="deactivated" fontSize={"14px"}>Sim</Typography>} />
                ) : (
                    <Chip label={<Typography className="activated" fontSize={"14px"}>Não</Typography>} />
                )}
            </div>
        ),
    },
    {
        field: "name",
        align: "left",
        width: 200,
        editable: false,
        sortable: true,
        renderHeader: () => (
            <Chip
                sx={{
                    color: "#fff",
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={"Nome"}
                icon={
                    <BadgeOutlined style={{ height: 30, width: 30, fill: "#ffff" }} />
                }
            />
        ),
        renderCell: (item) => (
            <Chip
                sx={{
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={item.row.name}
            />
        ),
    },
    {
        field: "cpf",
        align: "left",
        headerClassName: "last-column",
        width: 200,
        editable: false,
        sortable: true,
        renderHeader: () => (
            <Chip
                sx={{
                    color: "#fff",
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={"CPF/Matrícula"}
                icon={
                    <EmailOutlined style={{ height: 30, width: 30, fill: "#ffff" }} />
                }
            />
        ),
        renderCell: (item) => (
            <Chip
                sx={{
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={item.row?.driverCpf ? item.row?.driverCpf : (item.row?.driverRegistration ?? "-")}
            />
        ),
    },
    /*{
        field: "accessIcon",
        sortable: false,
        headerClassName: "last-column",
        width: 320,
        renderHeader: () => (
            <Chip
                sx={{
                    color: "#fff",
                    background: "transparent",
                    fontFamily: "Prometo",
                }}
                label={"Veiculos"}
                icon={
                    <CarRentalOutlined style={{ height: 30, width: 30, fill: "#ffff" }} />
                }
            />
        ),
        renderCell: (item) => (
            <>
                <Chip
                    sx={{
                        marginRight: 2,
                        fontFamily: "Prometo",
                        background: "#00B700",
                        color: "#ffff",
                        padding: 1,
                    }}
                    onClick={() => {
                        // dfdf
                    }}
                    label={item.row.vehicleList.length}
                    icon={
                        <VpnKeyOutlined style={{ height: 25, width: 25, fill: "#ffff" }} />
                    }
                />
            </>
        ),
    }*/
];

const rowsOptions = (
    list: Array<AccessType>,
    openDetails?: SetterOrUpdater<boolean>,
    callback?: (...args: any) => void,
    showOptions?: boolean
): Array<AccessType> => {
    const result = [...list];
    return result.map((item) => ({ ...item, openDetails, callback, showOptions }));
};

const RecordVehicleDriverComponent = () => {
    // atoms
    const getCurrentUser = useRecoilValue<UserType>(userAtom);

    const isAdmin = useMemo(
        () => getCurrentUser.configs.isManager && String(getCurrentUser.accessProfile.id) === PROFILE_ACESSES.ADMIN,
        [getCurrentUser.configs.isManager, getCurrentUser.accessProfile.id]
    );

    // cookies
    const [cookies] = useCookies([
        "selectedParameters",
        "token",
    ]);

    // funcionalities states
    const [isOnline, setIsOnline] = useState<boolean>(true);
    const [isOpenDetails, setIsOpenDetails] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [validationText, setTextValidation] = useState<string>("");
    const [isFieldsValid, setFieldsIsValid] = useState<boolean>(true);
    const [statusMessage, setStatusMessage] = useState<
        "warn" | "success" | "info" | "error" | undefined
    >("warn");
    const [isToastVisible, setIsToastVisible] = useState(false);

    const [inEdit, setInEdit] = useState<boolean>(false);
    const [inInsert, setInInsert] = useState<boolean>(false);
    const [isPasswordVisible, setIsPasswordVisible] = useState<boolean>(false);

    const [isLastPage, setIsLastPage] = useState<boolean>(true);
    const [numberOfElementsPerPage, setNumberOfElementsPerPage] = useState<number>(0);
    const [numberOfElements, setNumberOfElements] = useState<number>(0);
    const [pageNumber, setPageNumber] = useState<number>(0);

    const [report, setReport] = useState<ArrayBuffer>(new ArrayBuffer(0));
    const [exportType, setExportType] = useState<string>("");

    // states
    const [query, setQuery] = useState<string>("");
    const [filteredList, setFilteredList] = useState<Array<AccessType>>([]);
    const [selectedAccess, setSelectedAcess] = useState<AccessType>({
        id: -1,
        name: "",
        email: "",
        permissions: [],
        blocked: false,
        activated: true,
        departments: [],
        secretaries: [],
        userAccessProfileId: -1,
        driverCpf: "",
        driverRegistration: "",
        useRegisterNumber: false,
        vehicleList: [],
        isDriver: false,
        isManager: false,
        groups: [],
        login: null,
        useGtf: false,
    });

    const [accessesList, setAcessesList] = useState<Array<AccessType>>([]);
    const [name, setName] = useState<string>("");
    const [email, setEmail] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [isWeakPassword, setIsWeakPassword] = useState(false);
    const [debouncedQuery, setDebouncedQuery] = useState(query);
    const [lastRemoteQuery, setLastRemoteQuery] = useState("");

    const [customersList, setCustomersList] = useState<Array<CustomerListType>>([]);
    const [customer, setCustomer] = useState<CustomerListType>(customerDefault);
    const [secretary, setSecretary] = useState<SecretarySimpleType>(secretaryDefault);

    const [useRegisterNumber, setUseRegisterNumber] = useState<boolean>(false);
    const [driverRegistration, setDriverRegistration] = useState<string | null>("");
    const [driverCpfCurrent, setDriverCpfCurrent] = useState<string>("");

    const [vehiclePlateList, setVehiclePlateList] = useState<Array<string>>([]);
    const [plateCurrent, setPlateCurrent] = useState<string>("");

    const currentParameters: SelectedParametersType = useMemo(() => cookies.selectedParameters, [cookies.selectedParameters]);
    const [driverAccessFeatures, setDriverAccessFeatures] = useState<CustomerFeatureType | null>(null);
    const [vehicleOptions, setVehicleOptions] = useState<VehicleListType[]>([]);
    const [vehicleSearch, setVehicleSearch] = useState("");
    const [onlySelectedVehicles, setOnlySelectedVehicles] = useState(false);
    const [featuresLoading, setFeaturesLoading] = useState(false);
    const [vehiclesLoading, setVehiclesLoading] = useState(false);
    const [vehiclesCustomerId, setVehiclesCustomerId] = useState<number | null>(null);
    const activeCustomerId = getCurrentUser.configs.isManager ? customer.id : currentParameters?.customer.id;
    const featuresReady = activeCustomerId > 0 && !featuresLoading && driverAccessFeatures?.customerId === activeCustomerId;
    const driverLoginEnabled = featuresReady && driverAccessFeatures?.useDriverLogin === true;
    const driverControlEnabled = featuresReady && driverAccessFeatures?.useDriverControl === true;
    const vehiclesReady = !driverControlEnabled || (!vehiclesLoading && vehiclesCustomerId === activeCustomerId);
    const featureMessage = !activeCustomerId || activeCustomerId < 1
        ? "Selecione um cliente para consultar os acessos de condutores."
        : featuresLoading
            ? "Verificando os parâmetros do cliente..."
            : !featuresReady
                ? "Não foi possível verificar os parâmetros do cliente. Selecione-o novamente ou reabra a tela para tentar outra vez."
                : !driverLoginEnabled
                    ? "O login de condutores está desabilitado nos parâmetros do cliente. Não é possível criar novos acessos."
                    : "";
    const vehicleLabels = useMemo(() => {
        const labels = new Map<string, string>();
        selectedAccess.vehicleList?.forEach((vehicle) => labels.set(vehicle.vehiclePlate, `${vehicle.name} - ${vehicle.vehiclePlate}`));
        vehicleOptions.forEach((vehicle) => labels.set(vehicle.vehiclePlate,
            `${vehicle.name} - ${vehicle.vehiclePlate}${vehicle.deviceImei ? ` (${vehicle.deviceImei})` : ""}`));
        return labels;
    }, [vehicleOptions, selectedAccess.vehicleList]);
    const selectedVehiclePlates = useMemo(() => new Set(vehiclePlateList), [vehiclePlateList]);
    const driverVehicleOptions = useMemo(() => Array.from(new Set([...vehicleLabels.keys(), ...vehiclePlateList])), [vehicleLabels, vehiclePlateList]);
    const filteredVehicleOptions = useMemo(() => {
        return filterDriverVehicles(onlySelectedVehicles ? driverVehicleOptions.filter((plate) => selectedVehiclePlates.has(plate)) : driverVehicleOptions, {
            inputValue: vehicleSearch,
            getOptionLabel: (plate) => vehicleLabels.get(plate) ?? plate,
        });
    }, [driverVehicleOptions, vehicleLabels, onlySelectedVehicles, selectedVehiclePlates, vehicleSearch]);
    const [activeStep, setActiveStep] = useState(0);

    const toastModalRef = useRef<Toast>(null);
    const toastRef = useRef<Toast>(null);
    const cpfRef = useRef<any>(null);
    const plateRef = useRef<any>(null);

    useEffect(() => {
        if (!activeCustomerId || activeCustomerId < 1) {
            setDriverAccessFeatures(null);
            setFeaturesLoading(false);
            return;
        }
        let active = true;
        const token = cookies.token || sessionStorage.getItem("token") || "";
        setFeaturesLoading(true);
        setDriverAccessFeatures(null);
        const load = async () => {
            try {
                const features = getCurrentUser.configs.isManager
                    ? await findCustomerFeatures(token, activeCustomerId)
                    : await findCurrentCustomerFeatures(token);
                if (!active) return;
                if (features.customerId !== activeCustomerId) throw new Error("Cliente divergente nos parâmetros.");
                setDriverAccessFeatures(features);
            } catch (error) {
                if (!active) return;
                setTextValidation(getApiErrorMessage(error, "Não foi possível carregar os parâmetros do cliente. Selecione-o novamente ou reabra a tela para tentar outra vez."));
                setStatusMessage("warn");
                setFieldsIsValid(false);
            } finally {
                if (active) setFeaturesLoading(false);
            }
        };
        load();
        return () => { active = false; };
    }, [activeCustomerId, cookies.token, getCurrentUser.configs.isManager]);

    useEffect(() => {
        setVehicleOptions([]);
        setVehiclesCustomerId(null);
        setVehicleSearch("");
        setOnlySelectedVehicles(false);
        if (!isOpenDetails || !driverControlEnabled) {
            setVehiclesLoading(false);
            return;
        }
        let active = true;
        const token = cookies.token || sessionStorage.getItem("token") || "";
        setVehiclesLoading(true);
        findAllVehiclesByCustomerIdAndSecretaryIdAndDepartmentIdListResponse(token, activeCustomerId, -1, true)
            .then(({ data }) => {
                if (!active) return;
                setVehicleOptions(data);
                setVehiclesCustomerId(activeCustomerId);
            })
            .catch((error) => {
                if (!active) return;
                setTextValidation(getApiErrorMessage(error, "Não foi possível carregar os veículos do cliente. Feche e abra o cadastro para tentar novamente."));
                setStatusMessage("warn");
                setFieldsIsValid(false);
            })
            .finally(() => { if (active) setVehiclesLoading(false); });
        return () => { active = false; };
    }, [isOpenDetails, activeCustomerId, driverControlEnabled, cookies.token]);

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const getItemPermission = useCallback((id: number) => {
        return getCurrentUser.permissions.find((permission: PermissionsType) => {
            if (permission.optionItem.id === id) {
                const { optionItem, ...rest } = permission;
                return rest;
            };
        });
    }, [getCurrentUser.permissions]);

    const permissionToDriverAccess = useMemo(() => {
        if (!getCurrentUser?.configs?.isManager) {
            return getItemPermission(Number(MENUS_ITENS.DRIVER_ACCESSES));
        } else {
            return getItemPermission(Number(MENUS_ITENS.ACCESSES));
        }
    }, [getItemPermission, getCurrentUser?.configs?.isManager]);

    const handleClose = useCallback(() => {
        setLoading(false);
        setStatusMessage("warn");
        setIsToastVisible(false);
        setFieldsIsValid(true);
        setTextValidation("");
        setIsOpenDetails(false);
        setVehiclePlateList([]);
        setPlateCurrent("");
        setDriverCpfCurrent("");
        setActiveStep(0);
        setSecretary(secretaryDefault);
        setSelectedAcess({
            id: -1,
            name: "",
            activated: true,
            blocked: false,
            email: "",
            permissions: [],
            departments: [],
            secretaries: [],
            userAccessProfileId: -1,
            driverCpf: "",
            driverRegistration: "",
            useRegisterNumber: false,
            groups: [],
            isDriver: false,
            isManager: false,
            vehicleList: null,
            login: null,
            useGtf: false,
        });
        setInEdit(false);
        setInInsert(false);
        setName("");
        setEmail("");
        setPassword("");
    }, []);

    useEffect(() => {
        const ref = toastRef;
        if (validationText && !isFieldsValid && !isToastVisible) {
            setToastRefToOpen(
                ref,
                validationText,
                "Atenção!",
                statusMessage,
                undefined,
                3000,
                false
            );
        }
    }, [
        isOpenDetails,
        validationText,
        isFieldsValid,
        statusMessage,
        isToastVisible,
    ]);

    const getCustomersList = useCallback(async () => {
        const token = cookies.token || sessionStorage.getItem("token");
        try {
            const response = await customerFindAllListResponse(token, currentParameters.customer.id);
            setCustomersList(response.data);
        } catch (error) {
            console.log(error);
            setCustomersList([]);
        }
    }, [cookies.token, currentParameters]);

    useEffect(() => {
        if (getCurrentUser.configs.isManager) {
            getCustomersList();
        }
    }, [getCustomersList, getCurrentUser.configs.isManager]);

    const getAllAccesses = useCallback(
        async (search: string = "", status: string = "activated", page: number = 0, size: number = 100) => {
            const token: string = cookies.token || sessionStorage.getItem("token");
            const customerId = !getCurrentUser.configs.isManager ? currentParameters?.customer.id : customer.id;
            // const departmentId = -1;

            // const customerId = getCurrentUser.customer.id;
            const customerType = "driver";

            setLoading(true);
            try {
                const { data } = await findAllAcessesByCustomer(
                    token,
                    customerId,
                    getCurrentUser.id,
                    customerType,
                    status,
                    page,
                    size,
                    search
                );
                setAcessesList(data.content);
                setIsLastPage(data.last);
                setNumberOfElementsPerPage(data.numberOfElements);
                setPageNumber(data.pageable.pageNumber);

                if (data.first) {
                    setNumberOfElements(data.totalElements);
                }
            } catch (error: any) {
                console.log(error);
                setAcessesList([]);
            } finally {
                setTimeout(() => {
                    setLoading(false);
                }, 2000);
            }
        },
        [
            customer.id,
            currentParameters?.customer.id,
            getCurrentUser.configs.isManager,
            getCurrentUser.id,
            getCurrentUser.customer.id,
            cookies.token
        ]
    );

    useEffect(() => {
        getAllAccesses();
    }, [getAllAccesses]);

    const onSave = useCallback(async () => {
        if (!driverLoginEnabled || !vehiclesReady || !permissionToDriverAccess?.canCreate) return;
        const token: string = cookies.token || sessionStorage.getItem("token");
        const customerId = !getCurrentUser.configs.isManager ? currentParameters?.customer.id : customer.id;
        const customerType = "driver";

        setLoading(true);
        const data: AccessRequestType = {
            id: -1,
            name: "",
            email: "",
            login: null,
            useGtf: false,
            password: password,
            customerId: customerId,
            permissions: null,
            userAccessProfileId: Number(PROFILE_ACESSES.DRIVER),
            secretaries: null,
            departments: null,
            groups: null,
            driver: useRegisterNumber ? driverRegistration : driverCpfCurrent,
            vehicles: driverControlEnabled ? vehiclePlateList : null
        };

        if (
            !data.password ||
            !data.driver
            // data?.vehicles?.length === 0
        ) {
            setTextValidation(
                "Todos os campos marcados com * são obrigatórios, preencha e tente novamente."
            );
            setStatusMessage("warn");
            setFieldsIsValid(false);
            setLoading(false);
            return;
        }

        if (isWeakPassword) {
            setTextValidation(
                "A senha deve ter no mínimo 8 digitos, conter uma letra maiúscula, uma letra minúscula, números e pelo menos um caractere especial."
            );
            setStatusMessage("warn");
            setFieldsIsValid(false);
            setLoading(false);
            return;
        }

        try {
            await saveAcessesByCustomer(
                token,
                data,
                customerType
            );
            setTextValidation("Registro salvo com sucesso.");
            setStatusMessage("success");
            setFieldsIsValid(false);

            setTimeout(() => {
                handleClose();
                getAllAccesses();
            }, 3000);
        } catch (error: any) {
            setLoading(false);
            setFieldsIsValid(false);
            setStatusMessage("warn");
            setTextValidation(getApiErrorMessage(error, "Erro ao salvar o acesso do condutor."));
        }
    }, [
        password,
        cookies.token,
        handleClose,
        getCurrentUser.configs.isManager,
        currentParameters?.customer.id,
        customer.id,
        isWeakPassword,
        driverCpfCurrent,
        vehiclePlateList,
        getAllAccesses,
        driverLoginEnabled,
        vehiclesReady,
        permissionToDriverAccess?.canCreate,
        driverControlEnabled,
        useRegisterNumber,
        driverRegistration
    ]);

    const onUpdate = useCallback(async () => {
        if (!featuresReady || !vehiclesReady || !driverControlEnabled || !permissionToDriverAccess?.canEdit) return;
        const token: string = cookies.token || sessionStorage.getItem("token");
        const customerId = !getCurrentUser.configs.isManager ? currentParameters?.customer.id : customer.id;
        // const customerType = "driver";

        setLoading(true);
        const data: AccessRequestType = {
            id: selectedAccess.id,
            name: "",
            email: "",
            login: null,
            useGtf: false,
            customerId: customerId,
            permissions: null,
            userAccessProfileId: Number(PROFILE_ACESSES.DRIVER),
            secretaries: null,
            departments: null,
            groups: null,
            driver: selectedAccess.useRegisterNumber ? selectedAccess.driverRegistration : selectedAccess.driverCpf,
            vehicles: vehiclePlateList
        };

        if (
            !data.driver
            // data?.vehicles?.length === 0
        ) {
            setTextValidation(
                "Todos os campos marcados com * são obrigatórios, preencha e tente novamente."
            );
            setStatusMessage("warn");
            setFieldsIsValid(false);
            setLoading(false);
            return;
        }

        const originalPlates = selectedAccess.vehicleList?.map((vehicle) => vehicle.vehiclePlate) ?? [];
        const hasChanges = vehiclePlateList.length !== originalPlates.length ||
            vehiclePlateList.some((plate) => !originalPlates.includes(plate));

        if (
            !hasChanges
        ) {
            setTextValidation("Nada foi alterado.");
            setStatusMessage("warn");
            setFieldsIsValid(false);
            setLoading(false);
            return;
        }

        try {
            await updateUserByCustomer(
                token,
                data.id,
                data,
            );
            setTextValidation("Registro salvo com sucesso.");
            setStatusMessage("success");
            setFieldsIsValid(false);

            setTimeout(() => {
                handleClose();
                getAllAccesses();
            }, 3000);
        } catch (error: any) {
            setLoading(false);
            const { data } = error.response;

            const errors = data.reason.split(".");
            errors.forEach((message: any, index: number) => {
                if (index === 0) {
                    setFieldsIsValid(false);
                    setStatusMessage("warn");
                    setTextValidation(message);
                }
            });
        }
    }, [
        cookies.token,
        handleClose,
        getAllAccesses,
        getCurrentUser.configs.isManager,
        currentParameters?.customer.id,
        customer.id,
        selectedAccess.id,
        selectedAccess.vehicleList,
        vehiclePlateList,
        featuresReady,
        vehiclesReady,
        driverControlEnabled,
        permissionToDriverAccess?.canEdit,
        selectedAccess.useRegisterNumber,
        selectedAccess.driverRegistration,
        selectedAccess.driverCpf
    ]);

    const onUpdateStatus = useCallback(
        async (id: number, status: string) => {
            const token: string = cookies.token || sessionStorage.getItem("token");
            const customerId = !getCurrentUser.configs.isManager ? currentParameters?.customer.id : customer.id;

            setLoading(true);
            try {
                await updateUserStatusById(
                    token,
                    id,
                    customerId,
                    status
                );

                setTextValidation("Registro atualizado com sucesso.");
                setStatusMessage("success");
                setFieldsIsValid(false);

                setTimeout(() => {
                    handleClose();
                    getAllAccesses();
                }, 8000);
            } catch (error: any) {
                const { data } = error.response;
                setLoading(false);
                setFieldsIsValid(false);
                setStatusMessage("warn");
                setTextValidation(data.reason);
            }
        },
        [cookies.token, getCurrentUser.configs.isManager, currentParameters?.customer.id, customer.id, handleClose, getAllAccesses]
    );

    const verifyBeforeUpdateStatus = useCallback(
        (id: number, status: string) => {
            const ref = toastModalRef;
            if (!isToastVisible) {
                setToastRefToOpen(
                    ref,
                    "Deseja realmente atualizar o status desse registro?",
                    "Atenção!",
                    statusMessage,
                    {
                        content: (props: ContentProps) => (
                            <Box
                                className="flex flex-column align-items-left"
                                style={{ flex: "1" }}
                            >
                                <Typography>{props?.message.summary}</Typography>
                                <Box className="font-medium text-lg my-3 text-900">
                                    {props?.message.detail}
                                </Box>
                                <Button
                                    className="p-button-sm flex"
                                    style={{ cursor: "pointer", color: "inherit" }}
                                    onClick={() => {
                                        ref.current?.clear();
                                        setIsToastVisible(false);
                                        onUpdateStatus(id, status);
                                    }}
                                >
                                    Sim
                                </Button>
                                <Button
                                    className="p-button-sm flex"
                                    style={{ cursor: "pointer", color: "inherit" }}
                                    onClick={() => {
                                        ref.current?.clear();
                                        setIsToastVisible(false);
                                    }}
                                >
                                    Não
                                </Button>
                            </Box>
                        ),
                    },
                    undefined,
                    true
                );
                setIsToastVisible(true);
            }
        },
        [onUpdateStatus, isToastVisible, statusMessage]
    );

    const onResetPassword = useCallback(
        async (id: number) => {
            const token: string = cookies.token || sessionStorage.getItem("token");
            const customerId = !getCurrentUser.configs.isManager ? currentParameters?.customer.id : customer.id;

            setLoading(true);
            try {
                await resetUserPasswordById(token, id, customerId);

                setTextValidation("Senha resetada para a senha padrão com sucesso.");
                setStatusMessage("success");
                setFieldsIsValid(false);

                setTimeout(() => {
                    handleClose();
                    getAllAccesses();
                }, 8000);
            } catch (error: any) {
                setLoading(false);
                setFieldsIsValid(false);
                setStatusMessage("warn");
                setTextValidation(error.response?.data?.reason ?? "Não foi possível resetar a senha do condutor.");
            }
        },
        [cookies.token, getCurrentUser.configs.isManager, currentParameters?.customer.id, customer.id, handleClose, getAllAccesses]
    );

    const verifyBeforeResetPassword = useCallback(
        (id: number) => {
            const ref = toastModalRef;
            if (!isToastVisible) {
                setToastRefToOpen(
                    ref,
                    "Deseja realmente resetar a senha desse condutor para a senha padrão?",
                    "Atenção!",
                    statusMessage,
                    {
                        content: (props: ContentProps) => (
                            <Box
                                className="flex flex-column align-items-left"
                                style={{ flex: "1" }}
                            >
                                <Typography>{props?.message.summary}</Typography>
                                <Box className="font-medium text-lg my-3 text-900">
                                    {props?.message.detail}
                                </Box>
                                <Button
                                    className="p-button-sm flex"
                                    style={{ cursor: "pointer", color: "inherit" }}
                                    onClick={() => {
                                        ref.current?.clear();
                                        setIsToastVisible(false);
                                        onResetPassword(id);
                                    }}
                                >
                                    Sim
                                </Button>
                                <Button
                                    className="p-button-sm flex"
                                    style={{ cursor: "pointer", color: "inherit" }}
                                    onClick={() => {
                                        ref.current?.clear();
                                        setIsToastVisible(false);
                                    }}
                                >
                                    Não
                                </Button>
                            </Box>
                        ),
                    },
                    undefined,
                    true
                );
                setIsToastVisible(true);
            }
        },
        [onResetPassword, isToastVisible, statusMessage]
    );

    {/*const onUpdate = useCallback(async () => {
        const token: string = cookies.token || sessionStorage.getItem("token");
        setLoading(true);

        const customerId = !getCurrentUser.configs.isManager ? currentParameters?.customer.id : customer.id;
        const departmentId = (!getCurrentUser.configs.isManager && !currentParameters?.isViewingAll) ? currentParameters?.department.id : department.id;

        type VehicleDriverType = {
            customerId: number;
            departmentId: number;
            drivers: Array<string>;
            vehicles: Array<string>;
        };

        const data: VehicleDriverType = {
            customerId: customerId,
            departmentId: departmentId,
            drivers: driversCpfList.map((it) => it.replace(/\D/g, "")),
            vehicles: vehiclePlateList
        };

        try {
            await updateVehicleDriver(token, data);
            setTextValidation(`Registro${data.vehicles.length > 1 ? "s" : ""} atualizado com sucesso.`);
            setStatusMessage("success");
            setFieldsIsValid(false);

            setTimeout(() => {
                setLoading(false);
                handleClose();
            }, 3000);
        } catch (error: any) {
            setLoading(false);
            const { data } = error.response;

            const errors = data.reason.split(".");
            errors.forEach((message: any, index: number) => {
                if (index === 0) {
                    setFieldsIsValid(false);
                    setStatusMessage("warn");
                    setTextValidation(message);
                }
            });
        }
    }, [
        currentParameters?.isViewingAll,
        getCurrentUser.configs.isManager,
        currentParameters?.customer.id,
        currentParameters?.department.id,
        vehiclePlateList,
        driversCpfList,
        customer.id,
        secretary.id,
        department.id,
        cookies.token,
        handleClose
    ]);*/}

    {/*const handleCpfFormChange = useCallback(
        (value: string) => {
            const response = driversCpfList;
            const cpfLength = 11;

            if (value.replace(/\D/g, "").length === cpfLength && !response.includes(value)) {
                response.push(value);
                setDriverCpfList(response);
                setDriverCpfCurrent("");
            }
        },
        [driversCpfList]
    );*/}

    /*const handlePlateFormChange = useCallback(
        (value: string) => {
            const response = vehiclePlateList;
            // const plateLength = 7;

            if (!response.includes(value)) {
                response.push(value);
                setVehiclePlateList(response);
                setPlateCurrent("");
            }
        },
        [vehiclePlateList]
    );*/

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedQuery(query);
        }, 1000); // tempo para considerar que PAROU de digitar

        return () => clearTimeout(handler);
    }, [query]);

    const getBySearch = useCallback(() => {
        const localResult = getFilteredList(
            ["name", "cpf", "email", "cnh"],
            accessesList,
            debouncedQuery
        );

        if (localResult.length > 0) {
            setFilteredList(localResult);
        } else {
            setFilteredList([]);
        }

        // → evita loop: só chama API se query mudou
        if (debouncedQuery !== lastRemoteQuery && localResult.length <= 0) {
            setLastRemoteQuery(debouncedQuery);
            getAllAccesses(debouncedQuery);
        }
    }, [
        debouncedQuery,
        accessesList,
        getAllAccesses,
        lastRemoteQuery
    ]);

    useEffect(() => {
        getBySearch();
    }, [getBySearch]);

    const handleChange = useCallback((name: string, value: string) => {
        if (name === "name") {
            setName(value);
        }
        if (name === "email") {
            setEmail(value);
        }
        if (name === "password") {
            setPassword(value);
        }
    }, []);

    const handleOnEditValues = useCallback(
        async (selectedAccess: AccessType) => {
            if (selectedAccess.name && !inInsert) {
                setName(selectedAccess.name);
                setEmail(selectedAccess.email);
                setDriverCpfCurrent(selectedAccess?.driverCpf ?? "");
                setUseRegisterNumber(selectedAccess.useRegisterNumber);
                setDriverRegistration(selectedAccess?.driverRegistration);
                const vehicles = selectedAccess?.vehicleList?.map(veh => veh.vehiclePlate);
                setVehiclePlateList(vehicles ?? []);
                // setUserAccessProfileName(defaultManangerProfiles.find(item => item.id === selectedAccess.userAccessProfileId)?.name!!);
                // setSelectedSecretariesList(selectedAccess.secretaries.map(it => it.toString()));
                // await getDepartmentsList(selectedAccess.secretaries.map(it => it.toString()));
                //etSelectedDepartmentList(selectedAccess.departments.map(it => it.toString()));

                // await getGroupsList(selectedAccess.departments.map(it => it.toString()));
                // setSelectedGroupsList(selectedAccess.groups.map(it => it.toString()));
            }
        },
        [inInsert]
    );

    const getReport = useCallback(async (type: string) => {
        setLoading(true);
        const customerId = !getCurrentUser.configs.isManager ? currentParameters?.customer.id : customer.id;
        const customerType = "driver";

        let reportType = type;
        let isSimpleType = false;
        if (type.includes("simple")) {
            reportType = reportType.split(" ")[0];
            isSimpleType = true;
        };
        // simpleXlsxExport = false

        let dataBuffer = new ArrayBuffer(0);
        try {
            const { data } = await findAllUsersExportResponse(
                cookies.token,
                customerId,
                accessesList.length > 0 && accessesList[0].activated
                    ? "activated"
                    : "deactivated",
                reportType,
                customerType,
                isSimpleType
            );

            if ((data as ArrayBuffer).byteLength === 0) {
                setTextValidation("Nenhum dado para mostrar no relatório.");
                setStatusMessage("warn");
                setFieldsIsValid(false);
            } else {
                setTextValidation("Relatório gerado com sucesso.");
                setStatusMessage("success");
                setFieldsIsValid(false);
                dataBuffer = data;
            }
        } catch (error: any) {
            const { data } = error.response

            setLoading(false);
            setFieldsIsValid(false);
            setStatusMessage("warn");
            setTextValidation(data.reason);
        } finally {
            setTimeout(() => {
                handleClose();
                setReport(dataBuffer);
                setExportType(type);
            }, 3000);
        }
    }, [
        cookies.token,
        getCurrentUser.configs.isManager,
        currentParameters?.customer.id,
        customer.id,
        accessesList,
        handleClose
    ]);

    useEffect(() => {
        if (report.byteLength > 1) {
            const typeExport = (exportType === "pdf" ? 'application/pdf' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
            const file = new Blob([report], { type: typeExport });
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL);
            setReport(new ArrayBuffer(0));
        }
    }, [report, exportType]);

    const validate = useCallback((value: string) => {
        if (
            validator.isStrongPassword(value, {
                minLength: 6,
                minLowercase: 0,
                minUppercase: 0,
                minNumbers: 0,
                minSymbols: 1,
            })
        ) {
            setIsWeakPassword(false);
        } else {
            setIsWeakPassword(true);
        }
    }, []);

    useEffect(() => {
        if (password) {
            validate(password);
        }
    }, [password, validate]);

    const verifyBeforeCancel = useCallback(
        (selected: AccessType) => {
            const ref = toastModalRef;
            let canCancel = true;

            // verificar se houve diferença na lista de veiculos

            if (inEdit && !inInsert) {
                const originalPlates = selectedAccess.vehicleList?.map((vehicle) => vehicle.vehiclePlate) ?? [];
                const hasChanges = driverControlEnabled && (vehiclePlateList.length !== originalPlates.length ||
                    vehiclePlateList.some((plate) => !originalPlates.includes(plate)));
                if (
                    name !== selected.name ||
                    email !== selected.email ||
                    hasChanges
                ) {
                    canCancel = false;
                }
            } else if (!inEdit && inInsert) {
                if (
                    driverCpfCurrent ||
                    name ||
                    email ||
                    password ||
                    vehiclePlateList.length > 0
                ) {
                    canCancel = false;
                }
            }

            if (!canCancel) {
                if (!isToastVisible) {
                    setToastRefToOpen(
                        ref,
                        "Existem dados não salvos, deseja realmente cancelar?",
                        "Atenção!",
                        statusMessage,
                        {
                            content: (props: ContentProps) => (
                                <Box
                                    className="flex flex-column align-items-left"
                                    style={{ flex: "1" }}
                                >
                                    <Typography>{props?.message.summary}</Typography>
                                    <Box className="font-medium text-lg my-3 text-900">
                                        {props?.message.detail}
                                    </Box>
                                    <Button
                                        className="p-button-sm flex"
                                        style={{ cursor: "pointer", color: "inherit" }}
                                        onClick={() => {
                                            ref.current?.clear();
                                            handleClose();
                                        }}
                                    >
                                        Sim
                                    </Button>
                                    <Button
                                        className="p-button-sm flex"
                                        style={{ cursor: "pointer", color: "inherit" }}
                                        onClick={() => {
                                            ref.current?.clear();
                                            setIsToastVisible(false);
                                        }}
                                    >
                                        Não
                                    </Button>
                                </Box>
                            ),
                        },
                        undefined,
                        true
                    );
                    setIsToastVisible(true);
                }
            } else {
                handleClose();
            }
        },
        [
            inEdit,
            inInsert,
            handleClose,
            statusMessage,
            isToastVisible,
            driverCpfCurrent,
            vehiclePlateList.length,
            selectedAccess.vehicleList,
            driverControlEnabled,
            vehiclePlateList,
            name,
            email,
            password
        ]
    );

    const loadingEsqueleton = useMemo(() => {
        return (
            <Grid
                className="container "
                sx={{
                    height: 650,
                    width: 950,
                }}
            >
                {Array.from(new Array(1)).map((_, i) => (
                    <Box key={i} sx={{ width: "100%", height: 650, padding: 5 }}>
                        <Skeleton height={56} />
                        <Skeleton height={56} />
                        <Skeleton height={56} />
                        <Skeleton variant="rectangular" width={"100%"} height={350} />
                    </Box>
                ))}
            </Grid>
        );
    }, []);

    const IOSSwitch = useMemo(() => styled((props: SwitchProps) => (
        <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
    ))(({ theme }) => ({
        width: 42,
        height: 26,
        padding: 0,
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: 2,
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateX(16px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                    backgroundColor: '#65C466',
                    opacity: 1,
                    border: 0,
                    ...theme.applyStyles('dark', {
                        backgroundColor: '#2ECA45',
                    }),
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 0.5,
                },
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: '#33cf4d',
                border: '6px solid #fff',
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color: theme.palette.grey[100],
                ...theme.applyStyles('dark', {
                    color: theme.palette.grey[600],
                }),
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.7,
                ...theme.applyStyles('dark', {
                    opacity: 0.3,
                }),
            },
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 22,
            height: 22,
        },
        '& .MuiSwitch-track': {
            borderRadius: 26 / 2,
            backgroundColor: '#E9E9EA',
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 500,
            }),
            ...theme.applyStyles('dark', {
                backgroundColor: '#39393D',
            }),
        },
    })), []);

    const steps = useMemo(() => [
        {
            label: "Identificação",
            item: (
                <Paper className="trv-container tw-rounded-xl tw-border-0 tw-bg-white tw-shadow-none" elevation={0}>
                    <Box
                        className="col-md-12"
                        style={{ margin: "15px 0px 15px 0px" }}
                    >
                        <Autocomplete
                            id="chip-label-select-profile"
                            className="input-select-profile"
                            style={{
                                width: "100%",
                                minHeight: "56px",
                                height: "56px",
                                backgroundColor: "#ffffff29",
                                borderColor: "lightgray",
                            }}
                            options={[
                                {
                                    id: 1,
                                    name: "Condutor",
                                    description: "Para condutores do sistema",
                                },
                            ]}
                            value={{
                                id: 1,
                                name: "Condutor",
                                description: "Para condutores do sistema",
                            }}
                            onChange={(_, option) => {
                                // setUserAccessProfileName(option?.name ?? "");
                            }}
                            getOptionLabel={(option) => `${option.name}`}
                            noOptionsText={"Nada encontrado"}
                            renderInput={(params) => (
                                <>
                                    <FormControl
                                        className="form-group"
                                        style={{ display: "flex" }}
                                    >
                                        <InputLabel
                                            id="country-label"
                                            required
                                            style={{ color: "rgba(0, 0, 0, 0.6)", fontFamily: "Prometo" }}
                                            shrink
                                            disabled
                                        >
                                            Perfil
                                        </InputLabel>
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            placeholder="Selecione um perfil"
                                            autoComplete="off"
                                            required
                                            disabled
                                            InputLabelProps={{ shrink: true }}
                                            InputProps={{
                                                ...params.InputProps,
                                                notched: true,
                                                label: "Perfil",
                                                classes: {
                                                    notchedOutline: "custom-notch",
                                                },
                                            }}
                                        />
                                    </FormControl>
                                </>
                            )}
                            disabled
                        />
                    </Box>

                    <Box
                        className="col-md-12"
                        style={{ margin: "15px 0px 15px 0px" }}
                    >
                        <FormGroup>
                            <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                                <IOSSwitch
                                    title="Usar matrícula para cadastro"
                                    checked={useRegisterNumber}
                                    disabled={!!selectedAccess.name && !inInsert}
                                    onChange={(event) => {
                                        const checked = event.target.checked;
                                        if (!checked) {
                                            setDriverRegistration("");
                                        }
                                        setDriverCpfCurrent("");
                                        setUseRegisterNumber(checked);
                                    }}
                                    inputProps={{ 'aria-label': 'ant design' }}
                                />
                                <Typography style={{ color: "gray" }}>Usa matrícula</Typography>
                            </Stack>
                        </FormGroup>
                    </Box>
                    <Box className="col-md-12" style={{ margin: "15px 0px 15px 0px" }}>
                        {!useRegisterNumber && <FormControl
                            className="form-group"
                            style={{ display: "flex", width: "100%" }}
                        >
                            <InputLabel
                                id="demo-multiple-cpf-label"
                                shrink
                                required={!useRegisterNumber}
                                disabled={!!selectedAccess.name && !inInsert}
                            >
                                CPF
                            </InputLabel>
                            <TextField
                                name="cpf"
                                type="cpf"
                                required={!useRegisterNumber}
                                autoComplete="off"
                                inputProps={{ maxLength: 11 }}
                                InputProps={{ label: "CPF", notched: true }}
                                placeholder="Digite o CPF do motorista"
                                className="form-control driver-cpf"
                                value={cpfFormatter(driverCpfCurrent ?? "")}
                                onChange={(
                                    event: React.ChangeEvent<HTMLInputElement>
                                ) => {
                                    setDriverCpfCurrent(event.target.value);
                                }}
                                disabled={!!selectedAccess.name && !inInsert}
                            />
                            <IconButton
                                className="visibility-password"
                                disabled
                                onMouseDown={(e: SyntheticEvent) => { }}
                                edge="end"
                                size="large"
                            >
                                <PinOutlined />
                            </IconButton>
                        </FormControl>}

                        {useRegisterNumber && <FormControl
                            className="form-group"
                            style={{ display: "flex", width: "100%" }}
                        >
                            <InputLabel
                                id="demo-multiple-cpf-label"
                                shrink
                                required={useRegisterNumber}
                                disabled={!!selectedAccess.name && !inInsert}
                            >
                                Registro/Matrícula
                            </InputLabel>
                            <TextField
                                name="registrationNumber"
                                type="number"
                                required={useRegisterNumber}
                                autoComplete="off"
                                inputProps={{ maxLength: 25 }}
                                InputProps={{ label: "Registro/Matrícula", notched: true }}
                                placeholder="Digite a matrícula do motorista"
                                className="form-control driver-registrationNumber"
                                value={registerFormatter(driverRegistration ?? "")}
                                onChange={(
                                    event: React.ChangeEvent<HTMLInputElement>
                                ) => {
                                    setDriverRegistration(event.target.value);
                                }}
                                disabled={!!selectedAccess.name && !inInsert}
                            />
                            <IconButton
                                className="visibility-password"
                                disabled
                                onMouseDown={(e: SyntheticEvent) => { }}
                                edge="end"
                                size="large"
                            >
                                <PinOutlined />
                            </IconButton>
                        </FormControl>}
                    </Box>
                    {/*<Box
                        className="col-md-12"
                        style={{ margin: "15px 0px 15px 0px" }}
                    >
                        <FormControl
                            className="form-group"
                            style={{ display: "flex", width: "100%" }}
                        >
                            <InputLabel
                                id="demo-multiple-password-label"
                                shrink
                                required
                                disabled={
                                    (selectedAccess?.name &&
                                        !inEdit &&
                                        !inInsert) as boolean
                                }
                                style={{ fontFamily: "Prometo" }}
                            >
                                Nome
                            </InputLabel>
                            <TextField
                                name="name"
                                required
                                autoComplete="off"
                                InputProps={{
                                    label: "Nome",
                                    notched: true,
                                    style: { fontFamily: "Prometo" },
                                }}
                                disabled={
                                    (selectedAccess?.name &&
                                        !inEdit &&
                                        !inInsert) as boolean
                                }
                                value={name}
                                onChange={(e) => {
                                    handleChange(e.target.name, e.target.value);
                                }}
                                type="text"
                                className="form-control form-control-login"
                                placeholder="Digite o nome"
                            />
                            <IconButton
                                aria-label="toggle password visibility"
                                className="visibility-password"
                                disabled
                                onMouseDown={(e: SyntheticEvent) => { }}
                                edge="end"
                                size="large"
                            >
                                <BadgeOutlined />
                            </IconButton>
                        </FormControl>
                    </Box>*/}

                    {/*<Box
                        className="col-md-12"
                        style={{ margin: "15px 0px 15px 0px" }}
                    >
                        <FormControl
                            className="form-group"
                            style={{ display: "flex", width: "100%" }}
                        >
                            <InputLabel
                                id="demo-multiple-E-mail-label"
                                shrink
                                required
                                disabled={
                                    (selectedAccess?.name &&
                                        !inEdit &&
                                        !inInsert) as boolean
                                }
                                style={{ fontFamily: "Prometo" }}
                            >
                                E-mail
                            </InputLabel>
                            <TextField
                                name="email"
                                required
                                autoComplete="off"
                                InputProps={{
                                    label: "E-mail",
                                    notched: true,
                                    style: { fontFamily: "Prometo" },
                                }}
                                disabled={
                                    (selectedAccess?.name &&
                                        !inEdit &&
                                        !inInsert) as boolean
                                }
                                value={email}
                                onChange={(e) => {
                                    handleChange(e.target.name, e.target.value);
                                }}
                                type="text"
                                className="form-control form-control-login"
                                placeholder="Digite o e-mail"
                            />
                            <IconButton
                                aria-label="toggle password visibility"
                                className="visibility-password"
                                disabled
                                onMouseDown={(e: SyntheticEvent) => { }}
                                edge="end"
                                size="large"
                            >
                                <EmailOutlined />
                            </IconButton>
                        </FormControl>
                    </Box>*/}

                    {!selectedAccess.name && (
                        <Box
                            className="col-md-12"
                            style={{ margin: "15px 0px 0px 0px" }}
                        >
                            <FormControl
                                className="form-group"
                                style={{ display: "flex", width: "100%" }}
                            >
                                <InputLabel
                                    id="demo-multiple-password-label"
                                    shrink
                                    required
                                    style={{ fontFamily: "Prometo" }}
                                    disabled={
                                        (selectedAccess?.name &&
                                            !inEdit &&
                                            !inInsert) as boolean
                                    }
                                >
                                    Senha
                                </InputLabel>
                                <TextField
                                    name="password"
                                    required
                                    autoComplete="off"
                                    InputProps={{
                                        label: "Senha",
                                        notched: true,
                                        style: { fontFamily: "Prometo" },
                                    }}
                                    disabled={
                                        (selectedAccess?.name &&
                                            !inEdit &&
                                            !inInsert) as boolean
                                    }
                                    value={password}
                                    onChange={(e) => {
                                        handleChange(e.target.name, e.target.value)
                                    }}
                                    type={isPasswordVisible ? "text" : "password"}
                                    className="form-control form-control-login"
                                    placeholder="Digite a senha"
                                />
                                <IconButton
                                    aria-label="toggle password visibility"
                                    className="visibility-password"
                                    onClick={() => {
                                        setIsPasswordVisible(!isPasswordVisible);
                                    }}
                                    edge="end"
                                    size="large"
                                    disabled={
                                        (selectedAccess?.name &&
                                            !inEdit &&
                                            !inInsert) as boolean
                                    }
                                >
                                    {isPasswordVisible ? (
                                        <VisibilityOffOutlined />
                                    ) : (
                                        <VisibilityOutlined />
                                    )}
                                </IconButton>
                                <Box
                                    style={{
                                        display: "flex",
                                        marginTop: 10,
                                        marginLeft: -15,
                                    }}
                                >
                                    <FormHelperText
                                        style={{
                                            color: isWeakPassword ? "red" : "green",
                                            display: "flex",
                                        }}
                                    >
                                        {isWeakPassword &&
                                            password &&
                                            "A senha deve ter no mínimo 6 digitos e pelo menos um caractere especial."}
                                        {!isWeakPassword && password && (
                                            <>
                                                <LockPersonOutlined style={{ marginRight: 5 }} />
                                                <Typography>Senha forte</Typography>
                                            </>
                                        )}
                                    </FormHelperText>
                                </Box>
                            </FormControl>
                        </Box>
                    )}
                    {(featuresLoading || vehiclesLoading) && <Typography sx={{ my: 2 }}>Carregando parâmetros e veículos...</Typography>}
                    {!featuresLoading && !featuresReady && <Typography color="error" sx={{ my: 2 }}>
                        Não foi possível carregar os parâmetros. Selecione o cliente novamente ou reabra a tela para tentar outra vez.
                    </Typography>}
                    {featuresReady && driverAccessFeatures?.useDriverLogin === false && <Typography className="!tw-my-2 !tw-text-gtr-text-muted" variant="body2">
                        O login de condutores está desabilitado nos parâmetros do cliente. Não é possível criar novos acessos.
                    </Typography>}
                    {featuresReady && !vehiclesLoading && !vehiclesReady && <Typography color="error" sx={{ my: 2 }}>
                        Não foi possível carregar os veículos. Feche e abra o cadastro para tentar novamente.
                    </Typography>}
                    {driverControlEnabled && <Box sx={{ mt: 2, mb: 1, width: "100%" }}>
                        <Box className="tw-mb-3 tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-2">
                            <FormControlLabel sx={{ m: 0 }}
                                control={<Checkbox size="small" checked={onlySelectedVehicles} onChange={(_, checked) => setOnlySelectedVehicles(checked)} />}
                                label={<Typography variant="body2" className="!tw-text-gtr-text">Mostrar somente selecionados</Typography>}
                            />
                            <Tooltip title="Adiciona os resultados da pesquisa sem remover os veículos já selecionados." arrow>
                                <span><Button type="button" size="small" className="!tw-normal-case" disabled={(!inInsert && !inEdit) || filteredVehicleOptions.every((plate) => selectedVehiclePlates.has(plate))}
                                    onClick={() => setVehiclePlateList((current) => Array.from(new Set([...current, ...filteredVehicleOptions])))}>
                                    Selecionar resultados ({filteredVehicleOptions.length})
                                </Button></span>
                            </Tooltip>
                        </Box>
                        <Autocomplete
                            multiple
                            fullWidth
                            disableCloseOnSelect
                            options={driverVehicleOptions}
                            filterOptions={() => filteredVehicleOptions}
                            inputValue={vehicleSearch}
                            onInputChange={(_, value, reason) => {
                                if (reason === "input" || reason === "clear") setVehicleSearch(value);
                            }}
                            value={vehiclePlateList}
                            disableClearable={!inInsert && !inEdit}
                            getOptionDisabled={() => !inInsert && !inEdit}
                            onChange={(_, value) => { if (inInsert || inEdit) setVehiclePlateList(value); }}
                            getOptionLabel={(plate) => vehicleLabels.get(plate) ?? plate}
                            renderTags={(value) => <Chip size="small" label={`${value.length} selecionado${value.length === 1 ? "" : "s"}`} className="!tw-m-1 !tw-max-w-full" />}
                            renderOption={(props, plate, { selected }) => <li {...props} key={plate}>
                                <Checkbox checked={selected} tabIndex={-1} disableRipple inputProps={{ "aria-hidden": true }} sx={{ pointerEvents: "none", mr: 1, p: 0.5, flexShrink: 0 }} />
                                <Box component="span" className="tw-min-w-0 tw-break-words">{vehicleLabels.get(plate) ?? plate}</Box>
                            </li>}
                            ListboxProps={{ style: { maxHeight: 260, overflowY: "auto", scrollbarWidth: "thin", overscrollBehavior: "contain" } }}
                            noOptionsText={onlySelectedVehicles ? "Nenhum veículo selecionado para esta pesquisa" : "Nenhum veículo encontrado"}
                            renderInput={(params) => <TextField
                                {...params}
                                label="Veículos liberados"
                                placeholder="Pesquise por nome, placa ou IMEI"
                                InputLabelProps={{ shrink: true }}
                                helperText="Sem veículos selecionados, o condutor não poderá visualizar nenhum veículo."
                            />}
                        />
                    </Box>}
                </Paper>
            ),
        },
        {
            label: "",
            item: (
                <Paper className="trv-container tw-rounded-xl tw-border-0 tw-bg-white tw-shadow-none" elevation={0}>
                    {/**<Box className="col-md-12" style={{ margin: "15px 0px 15px 0px" }}>
                        <FormControl
                            className="form-group"
                            style={{ display: "flex", width: "100%" }}
                        >
                            <InputLabel id="demo-multiple-cpf-label" shrink disabled={false} required>
                                Veículo
                            </InputLabel>
                            <TextField
                                name="plate"
                                type="text"
                                ref={(ref) => (plateRef.current = ref)}
                                autoComplete="off"
                                required
                                inputProps={{ maxLength: 7 }}
                                InputProps={{ label: "Veículo", notched: true }}
                                placeholder="Digite a placa ou nome do veículo"
                                className="form-control vehicle-plate"
                                value={plateCurrent}
                                onKeyDown={(event) =>
                                    event.key === "Enter"
                                        ? (plateRef.current.onchange = (e: any) =>
                                            handlePlateFormChange(e.target.value))
                                        : null
                                }
                                onChange={(e) => setPlateCurrent(e.target.value)}
                                disabled={false}
                            />
                            <IconButton
                                className="visibility-password"
                                disabled
                                onMouseDown={(e: SyntheticEvent) => { }}
                                edge="end"
                                size="large"
                            >
                                <PinOutlined />
                            </IconButton>
                        </FormControl>
                    </Box>**/}
                    {/*
                    <Box
                        sx={{
                            display: "block",
                            maxHeight: 250,
                            overflowY: "auto",
                            border: "1px solid #ddd",
                            padding: 1,
                            borderRadius: 1,

                            scrollbarWidth: "thin",
                            scrollbarColor: "#c1c1c1 transparent",

                            "&::-webkit-scrollbar": {
                                width: "6px",
                            },
                            "&::-webkit-scrollbar-track": {
                                background: "transparent",
                            },
                            "&::-webkit-scrollbar-thumb": {
                                backgroundColor: "#c1c1c1",
                                borderRadius: "8px",
                            },
                            "&::-webkit-scrollbar-thumb:hover": {
                                backgroundColor: "#a0a0a0",
                            },
                        }}
                    >
                        {vehiclePlateList.map((it) => {
                            return (
                                <Chip
                                    key={it}
                                    label={it.toUpperCase()}
                                    onDelete={() => {
                                        const newList = vehiclePlateList.filter((item) => item !== it);
                                        setVehiclePlateList(newList);
                                    }}
                                    sx={{ margin: 0.5 }}
                                />
                            );
                        })}
                    </Box>
                    */}
                </Paper>
            ),
        },
    ], [driverCpfCurrent, IOSSwitch, driverRegistration, useRegisterNumber, handleChange, inEdit, inInsert, isWeakPassword, isPasswordVisible, password, selectedAccess.name,
        featuresLoading, featuresReady, vehiclesLoading, vehiclesReady, driverControlEnabled, driverAccessFeatures?.useDriverLogin, vehicleSearch, onlySelectedVehicles,
        vehicleLabels, driverVehicleOptions, filteredVehicleOptions, selectedVehiclePlates, vehiclePlateList
    ]);

    const DetailsModal = useMemo(() => {
        return (
            <Rmodal
                open={isOpenDetails}
                toast={
                    <Toast
                        ref={toastModalRef}
                        position="center"
                        onShow={() => {
                            setIsToastVisible(true);

                            if (validationText) {
                                setTimeout(() => {
                                    setFieldsIsValid(true);
                                    setIsToastVisible(false);
                                }, 3000);
                            }
                        }}
                    />
                }
            >
                <Paper className="tw-flex tw-flex-col tw-overflow-hidden tw-rounded-2xl tw-bg-white tw-shadow-none tw-transition-all tw-duration-300 tw-ease-gtr-smooth" elevation={0} sx={stylePaper}>
                    <Box
                        className="row permissions-paper tw-m-0 tw-flex-1 tw-overflow-y-auto tw-bg-white tw-p-3"
                        sx={{
                            margin: 0,
                            width: "100%",
                            flex: 1,
                            overflowY: "auto",
                            backgroundColor: "#ffff",
                            boxShadow: "none",
                            padding: 1.5,
                            scrollbarWidth: "thin",
                            scrollbarColor: "#006C77 transparent",
                            "& .MuiOutlinedInput-root": { borderRadius: 2, backgroundColor: "#ffff", transition: "box-shadow 200ms ease, background-color 200ms ease" },
                            "& .MuiInputLabel-root.Mui-focused": { color: "#00B700" },
                            "& .MuiOutlinedInput-root.Mui-focused": { boxShadow: "0 0 0 3px rgba(0,183,0,0.12)" },
                            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#00B700" },
                        }}
                    >
                        {!loading ?
                            <>
                                <Box className="col-sm-12 col-md-7 d-none d-md-flex">
                                    <Typography variant="body1" sx={{ fontWeight: "bolder" }}>
                                        Identificação
                                    </Typography>
                                </Box>
                                <Box
                                    className="col-sm-12 col-md-5 tw-flex tw-flex-wrap tw-items-center tw-justify-end tw-gap-2"
                                    style={{ display: "flex", justifyContent: "end", alignItems: "center", flexWrap: "wrap", gap: 5 }}
                                >
                                    {selectedAccess?.name && (
                                        <>
                                            <Chip
                                                style={{
                                                    color: selectedAccess.activated
                                                        ? "#00B700"
                                                        : "#dc3545",
                                                    marginRight: 0,
                                                    width: "auto",
                                                    fontWeight: "bolder",
                                                }}
                                                clickable={false}
                                                onClick={() => { }}
                                                label={selectedAccess.activated ? "Ativo" : "Inativo"}
                                            />
                                            {selectedAccess.activated && (
                                                <Tooltip title={driverControlEnabled ? "Editar veículos liberados para o condutor" : "Edição indisponível: o controle de condutores está desativado"} arrow>
                                                    <span>
                                                        <Chip
                                                            style={{ color: "black", marginRight: 0, width: "auto" }}
                                                            disabled={!driverControlEnabled || !permissionToDriverAccess?.canEdit || isImpersonationLocked()}
                                                            onClick={() => setInEdit(true)}
                                                            label="Editar"
                                                            icon={<DriveFileRenameOutlineOutlined style={{ height: 24, width: 24, fill: "black" }} />}
                                                        />
                                                    </span>
                                                </Tooltip>
                                            )}
                                            {selectedAccess.activated && (
                                                <Chip
                                                    style={{ color: "black", marginRight: 0, width: "auto" }}
                                                    disabled={isImpersonationLocked()}
                                                    onClick={() => {
                                                        if (!isToastVisible) {
                                                            verifyBeforeUpdateStatus(
                                                                selectedAccess.id,
                                                                selectedAccess.blocked ? "unblock" : "block"
                                                            );
                                                        }
                                                    }}
                                                    label={selectedAccess.blocked ? "Desbloquear" : "Bloquear"}
                                                    icon={<DeleteForeverOutlined style={{ height: 24, width: 24, fill: "black" }} />}
                                                />
                                            )}
                                            <Chip
                                                style={{ color: "black", marginRight: 0, width: "auto" }}
                                                disabled={isImpersonationLocked()}
                                                onClick={() => {
                                                    if (!isToastVisible) {
                                                        verifyBeforeUpdateStatus(
                                                            selectedAccess.id,
                                                            selectedAccess.activated
                                                                ? "deactivate"
                                                            : "activate"
                                                        );
                                                    }
                                                }}
                                                label={selectedAccess.activated ? "Desativar" : "Ativar"}
                                                icon={<RemoveCircleOutlineOutlined style={{ height: 24, width: 24, fill: "black" }} />}
                                            />
                                            {isAdmin && selectedAccess.activated && !selectedAccess.useRegisterNumber && !!selectedAccess.driverCpf && (
                                                <Chip
                                                    style={{ color: "black", marginRight: 0, width: "auto" }}
                                                    disabled={isImpersonationLocked()}
                                                    onClick={() => {
                                                        if (!isToastVisible) {
                                                            verifyBeforeResetPassword(selectedAccess.id);
                                                        }
                                                    }}
                                                    label="Resetar senha"
                                                    icon={<LockResetOutlined style={{ height: 24, width: 24, fill: "black" }} />}
                                                />
                                            )}
                                        </>
                                    )}
                                    <Tooltip title="Fechar" arrow>
                                        <IconButton
                                            aria-label="Fechar edição do condutor"
                                            onClick={handleClose}
                                            size="small"
                                            sx={{
                                                color: "#334155",
                                                marginLeft: 0.5,
                                                transition: "color 200ms ease, background-color 200ms ease",
                                                "&:hover": { color: "#dc3545", backgroundColor: "rgba(220,53,69,0.10)" },
                                            }}
                                        >
                                            <CloseOutlined />
                                        </IconButton>
                                    </Tooltip>
                                </Box>

                                <Stepper
                                    activeStep={activeStep}
                                    orientation="vertical"
                                    sx={{
                                        background: "",
                                        width: "100%",
                                        minWidth: 0,
                                        padding: 0,
                                        "& .MuiStepContent-root": { paddingLeft: { xs: 1, sm: 2 }, paddingRight: 0 },
                                        "& .trv-container": { width: "100%", minWidth: 0, padding: { xs: 1, sm: 1.5 } },
                                        "& .trv-container > .col-md-12": { padding: 0 },
                                        "& .Mui-active": {
                                            fill: "#003f4a",
                                        },
                                        "& .Mui-completed": {
                                            fill: "#00b700",
                                            color: "#ffff",
                                        },
                                    }}
                                >
                                    {steps.filter((step) => step.label).map((step, index) => (
                                        <Step key={step.label} >
                                            <StepLabel
                                                optional={
                                                    index === (steps.length - 1) ? (
                                                        <Typography variant="caption">
                                                            Insira os veículos que o motorista terá permissão de visualizar
                                                        </Typography>
                                                    ) : index === 0 ? (
                                                        <Typography variant="caption">
                                                            Digite os dados do motorista
                                                        </Typography>
                                                    ) : null
                                                }
                                            >
                                                {step.label}
                                            </StepLabel>
                                            <StepContent>
                                                {step.item}
                                                <Paper
                                                    className="tw-flex tw-w-full tw-flex-wrap tw-justify-end tw-gap-2 tw-border-t tw-border-black/5 tw-pt-3"
                                                    elevation={0}
                                                    sx={{
                                                        display: "flex",
                                                        justifyContent: "flex-end",
                                                        alignItems: "center",
                                                        flexWrap: "wrap",
                                                        width: "100%",
                                                        gap: 1,
                                                        background: "transparent",
                                                        marginTop: 2.5,
                                                        paddingTop: 1.5,
                                                        borderTop: "1px solid rgba(0,0,0,0.05)",
                                                    }}
                                                >
                                                    <Button
                                                        type="button"
                                                        style={{
                                                            fontFamily: "Prometo",
                                                            color: "#ffff",
                                                            background: "rgba(220, 53, 69, 1)",
                                                            margin: 5,
                                                        }}
                                                        onClick={() => {
                                                            if (!isToastVisible) {
                                                                verifyBeforeCancel(selectedAccess);
                                                            }
                                                        }}
                                                        disabled={false}
                                                        className="btn btn-primary btn-block login-button-close tw-transition-transform tw-duration-200 hover:tw-translate-y-[-1px]"
                                                    >
                                                        <CloseOutlined style={{ marginRight: 5 }} />
                                                        <Typography
                                                            className="forgot-password"
                                                            style={{
                                                                fontFamily: "Prometo",
                                                                fontSize: "16px",
                                                                color: "#ffff",
                                                            }}
                                                        >
                                                            {"Fechar"}
                                                        </Typography>
                                                    </Button>

                                                    {/*<Button
                                                        type="button"
                                                        style={{
                                                            background: "orange",
                                                            fontFamily: "Prometo",
                                                            color: "#ffff",
                                                            margin: 5,
                                                        }}
                                                        onClick={handleBack}
                                                        disabled={index === 0}
                                                        className="btn btn-primary btn-block login-button tw-transition-transform tw-duration-200 hover:tw-translate-y-[-1px]"
                                                    >
                                                        <UndoOutlined style={{ marginRight: 5 }} />
                                                        <Typography
                                                            className="forgot-password"
                                                            style={{
                                                                fontFamily: "Prometo",
                                                                fontSize: "16px",
                                                                color: "#ffff",
                                                            }}
                                                        >
                                                            {"Voltar"}
                                                        </Typography>
                                                    </Button>*/}

                                                    <Button
                                                        type="button"
                                                        style={{ fontFamily: "Prometo", color: "#ffff", margin: 5 }}
                                                        onClick={() => { index === steps.filter((step) => step.label).length - 1 ? (inInsert && !inEdit ? onSave() : onUpdate()) : handleNext() }}
                                                        className="btn btn-primary btn-block login-button tw-transition-transform tw-duration-200 hover:tw-translate-y-[-1px]"
                                                        sx={{
                                                            minWidth: 120,
                                                            minHeight: 40,
                                                            borderRadius: 2,
                                                            backgroundColor: "#00B700",
                                                            boxShadow: "none",
                                                            "&:hover": { backgroundColor: "#009900", boxShadow: "0 6px 14px rgba(0,183,0,0.20)" },
                                                        }}
                                                        disabled={
                                                            !featuresReady || !vehiclesReady || (inInsert && !driverLoginEnabled) || (!inInsert && !inEdit) ||
                                                            (inInsert ? !permissionToDriverAccess?.canCreate : !permissionToDriverAccess?.canEdit) ||
                                                            (inInsert && ((!driverCpfCurrent && !useRegisterNumber) || (!driverRegistration && useRegisterNumber) || !password || isWeakPassword)) ||
                                                            isImpersonationLocked()
                                                        }
                                                    >
                                                        {index === steps.filter((step) => step.label).length - 1 ? <SaveOutlined style={{ marginRight: 5 }} /> : <ArrowForwardOutlined style={{ marginRight: 5 }} />}
                                                        <Typography
                                                            className="forgot-password"
                                                            style={{
                                                                fontFamily: "Prometo",
                                                                fontSize: "16px",
                                                                color: "#ffff",
                                                            }}
                                                        >
                                                            {index === steps.filter((step) => step.label).length - 1 ? "Salvar" : "Próximo"}
                                                        </Typography>
                                                    </Button>
                                                </Paper>
                                            </StepContent>
                                        </Step>
                                    ))}
                                </Stepper>
                            </> : (
                                loadingEsqueleton
                            )}
                    </Box>
                </Paper>
            </Rmodal>);
    }, [onSave, handleClose, driverRegistration, permissionToDriverAccess?.canEdit, permissionToDriverAccess?.canCreate, useRegisterNumber, verifyBeforeUpdateStatus, selectedAccess, verifyBeforeCancel, driverCpfCurrent, inEdit, inInsert, isWeakPassword, password, isOpenDetails, isToastVisible, loading, loadingEsqueleton, vehiclePlateList.length, activeStep, onUpdate, steps, validationText, isAdmin, verifyBeforeResetPassword, featuresReady, driverControlEnabled, driverLoginEnabled, vehiclesReady]);

    // return template;

    const customerParam = useMemo(() =>
        <>
            {getCurrentUser.configs.isManager && <Box className="col-md-12" style={{ marginBottom: 5, marginTop: 5 }}>
                <Autocomplete
                    id="chip-label-select-customer"
                    className="input-select-customer"
                    style={{
                        width: "100%",
                        minHeight: "56px",
                        height: "56px",
                        backgroundColor: "#ffffff",
                        borderColor: "lightgray",
                    }}
                    options={customersList}
                    value={customer}
                    onChange={(_, option) => {
                        setCustomer(option ?? customerDefault);
                        setAcessesList([]);
                        setSelectedAcess({
                            id: -1,
                            name: "",
                            email: "",
                            permissions: [],
                            blocked: false,
                            activated: true,
                            departments: [],
                            secretaries: [],
                            userAccessProfileId: -1,
                            driverCpf: "",
                            driverRegistration: "",
                            useRegisterNumber: false,
                            vehicleList: [],
                            isDriver: false,
                            isManager: false,
                            groups: [],
                            login: null,
                            useGtf: false,
                        });
                    }}
                    // disabled={!getCurrentUser.configs.isManager}
                    getOptionLabel={(option) => `${option.reducedName}`}
                    noOptionsText={"Nada encontrado"}
                    renderInput={(params) => (
                        <>
                            <FormControl
                                className="form-group"
                                style={{ display: "flex" }}
                            >
                                <InputLabel
                                    id="country-label"
                                    required
                                    style={{ color: "rgba(0, 0, 0, 0.6)", fontFamily: "Prometo" }}
                                    shrink
                                >
                                    Cliente
                                </InputLabel>
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    placeholder="Selecione um cliente"
                                    style={{ background: "#ffff", borderRadius: 8 }}
                                    autoComplete="off"
                                    required
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{
                                        ...params.InputProps,
                                        notched: true,
                                        label: "Cliente",
                                        classes: {
                                            notchedOutline: "custom-notch",
                                        },
                                    }}
                                />
                            </FormControl>
                        </>
                    )}
                />
            </Box>}
        </>,
        [customer,
            customersList,
            getCurrentUser.configs.isManager
        ]);

    return (
        <>
            {DetailsModal}
            <Toast
                ref={toastRef}
                position="center"
                onShow={() => {
                    setIsToastVisible(true);

                    if (validationText) {
                        setTimeout(() => {
                            setFieldsIsValid(true);
                            setIsToastVisible(false);
                        }, 3000);
                    }
                }}
            />
            <GridTemplate
                columns={columns}
                headerName="Acesso do condutor"
                isHiddenMenu={false}
                isLoading={loading}
                order={"asc"}
                rows={rowsOptions(filteredList)}
                sortField="description"
                withFilter={true}
                withOptions={true}
                query={query}
                setQuery={(value: string) => setQuery(value)}
                filterPlaceholder={"Nome"}
                onRefresh={getAllAccesses}
                onExport={getReport}
                disableAddButton={!permissionToDriverAccess?.canCreate || !driverLoginEnabled}
                disableOptionsButton={!driverLoginEnabled}
                optionsDisabledReason={featureMessage}
                handleNext={(activated: string, page: number, size: number) => getAllAccesses("", activated, page, size)}
                handlePrevious={() => { }}
                isLastPage={isLastPage}
                totalPerPage={numberOfElementsPerPage}
                currentPage={pageNumber}
                totalElements={numberOfElements}
                contentHeight={"500px"}
                containerHeight="auto"
                style={{ width: "100%", marginTop: 0, padding: 0 }}
                onAdd={() => {
                    if (!permissionToDriverAccess?.canCreate || !driverLoginEnabled) return;
                    setIsOpenDetails(true);
                    setInInsert(true);
                    setInEdit(false);
                    setLoading(true);
                    setTimeout(() => {
                        setLoading(false);
                    }, 2000);
                }}
                onClickRow={(item: any) => {
                    setIsOpenDetails(true);
                    setSelectedAcess(item);
                    handleOnEditValues(item);
                    setLoading(true);
                    setTimeout(() => {
                        setLoading(false);
                    }, 2000);
                }}
                withCustomerParameter={getCurrentUser?.configs.isManager}
                customerParameter={customerParam}
            />
        </>
    );
};

const style = {
    bgcolor: "#ffff",
    border: "none",
    boxShadow: "none",
    borderRadius: 1,
    color: "black",
    justifyContent: "center",
    alignItems: "center",
    lineBreak: "anywhere",
    padding: 3,
    fontFamily: "Prometo",
};

const stylePaper = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    flexDirection: "column",
    width: { xs: "calc(100vw - 24px)", sm: "min(94vw, 1100px)" },
    maxWidth: 1100,
    maxHeight: "calc(100dvh - 24px)",
    overflow: "hidden",
    bgcolor: "#ffff",
    border: "none",
    boxShadow: "none",
    borderRadius: 4,
    color: "black",
    justifyContent: "flex-start",
    alignItems: "stretch",
    lineBreak: "anywhere",
    padding: 0,
    fontFamily: "Prometo",
};

export default RecordVehicleDriverComponent;
